import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Text, Flex, ToggleButton, Toggle, Checkbox } from '@leverege/ui-elements'
import { LabelGroup } from '~/views'

import style from './style.css'

export default class PlacementEditor extends React.Component {
  static propTypes = {
    setDrawMode : PropTypes.func.isRequired,
    onDeleteShape : PropTypes.func.isRequired,
    geotile : PropTypes.object.isRequired,
  }
  
  setDrawMode = ( nMode ) => {
    const { mode, setDrawMode } = this.props
    if ( mode !== nMode ) {
      setDrawMode( nMode )
    }
  }

  render() {
    const { onDeleteShape, geotile } = this.props
    const { sourceImagePath, editor : { drawMode : mode } } = geotile
    const disabled = !sourceImagePath
    return (
      <>
        {disabled && <Text>Select an image before drawing boundaries</Text>}
        <Flex>
          <ToggleButton 
            value={mode === 'draw_rectangle'} 
            eventData="draw_rectangle" 
            iconOn="fa fa-pencil-square-o" 
            iconOff="fa fa-pencil-square-o" 
            iconPosition="start" 
            disabled={disabled}
            onChange={( { data } ) => this.setDrawMode( data )}>
            Draw
          </ToggleButton>
          <ToggleButton 
            value={mode === 'simple_select'} 
            eventData="simple_select" 
            iconOn="fa fa-arrows" 
            iconOff="fa fa-arrows" 
            iconPosition="start" 
            disabled={disabled}
            onChange={( { data } ) => this.setDrawMode( data )}>
            Move
          </ToggleButton>
          <ToggleButton 
            value={mode === 'rotate'} 
            eventData="rotate" 
            iconOn="fa fa-repeat" 
            iconOff="fa fa-repeat" 
            iconPosition="start" 
            disabled={disabled}
            onChange={( { data } ) => this.setDrawMode( data )}>
            Rotate
          </ToggleButton>
          <ToggleButton 
            value={mode === 'resize'} 
            eventData="resize" 
            iconOn="fa fa-expand" 
            iconOff="fa fa-expand" 
            iconPosition="start" 
            disabled={disabled}
            onChange={( { data } ) => this.setDrawMode( data )}>
            Resize
          </ToggleButton>
        </Flex>
        {/* <LabelGroup style={{ marginBottom: '12px', flexBasis : '200px', marginRight : '8px' }}>
          <label>Keep Aspect</label>
          <Flex align="center">
            <Toggle value={keepAspect} onChange={toggleAspect} />
          </Flex>
        </LabelGroup> */}
        <div>
          <Text>Keyboard</Text>
          <div style={{ padding : '0 8px 8px 8px' }}>
            <Text variant="caption">C: Generate polygon in center of screen</Text>
            <Text variant="caption">c: Move polygon to center of screen</Text>
            <Text variant="caption">k, l: Rotate</Text>
            <Text variant="caption">i, o: Scale</Text>
            <Text variant="caption">a, w, s, d: Move</Text>
            <Text variant="caption">Hold shift for finer grain adjustments</Text>
          </div>
        
        </div>
        <button className={style.trash} onClick={onDeleteShape}>Delete Shape<i className="fa fa-trash" /></button>
      </>
    )
  }
}
